module.exports = __webpack_public_path__ + "static/media/first_aid.5e6cb976.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/first_aid.svg
// module id = 550
// module chunks = 0